import { Module, ModuleShare } from "types/generated";

export const generateUniqueSharedAccounts = (moduleShares: ModuleShare[]) => {
  const sharedAccountsFiltered = moduleShares.filter(
    (share) =>
      !share.to.space &&
      share.to.account?.subdomain &&
      share.to.account.subdomain !== share.from.account.subdomain
  );
  const sharedAccountsSet = [
    ...new Set(sharedAccountsFiltered.map((share) => share.to.account.subdomain)),
  ];

  return sharedAccountsSet;
};

export const getDefaultValues = (module: Module) => {
  const uniqueSharedAccounts = generateUniqueSharedAccounts(module.moduleShares);

  const sharedAccounts =
    uniqueSharedAccounts.length === 0
      ? [{ value: "" }]
      : uniqueSharedAccounts.map((share) => ({ value: share }));

  const sharedSpaces = module?.moduleShares.filter((share) => share.to.space);
  const mappedSharedSpaces =
    sharedSpaces.length === 0
      ? [{ value: "" }]
      : sharedSpaces.map((space) => ({ value: space.to.space?.id }));

  return {
    sharedAccounts,
    sharedSpaces: mappedSharedSpaces,
  };
};
